import { Table } from "antd";
import React from "react";
import moment from 'moment'
import Delete from "../../../../assets/images/delete_icon.svg";
import Info from "../../../../assets/images/info.png";
import Edit from "../../../../assets/images/edit_icon.svg";

const TableSection = (props) => {
    const { onDelete, onEditClick, userList, onInfoClick, loading, setDefaultPage, defaultPage } = props;
    const formatPhoneNumber =(phone)=> {
      // Remove all non-digit characters
      const cleaned = phone.replace(/\D/g, "");
    
      // Ensure it's at least 10 digits
      if (cleaned.length !== 10) return phone;
    
      const part1 = cleaned.slice(0, 3);
      const part2 = cleaned.slice(3, 6);
      const part3 = cleaned.slice(6, 10);
    
      return `(${part1}) ${part2} - ${part3}`;
    }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '30%',
            render:(field, record) => {
              return <div onClick={()=>{onInfoClick(record)}} className="img_column">
                <img src={record.photo_url} height="25px" alt="" />
                <span className="emp_name">{field}</span>
              </div>
            } 
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: '20%',
            render:(field, record) => {
              return <div onClick={()=>{onInfoClick(record)}}>{field}</div>
            }
        },
        {
          title: 'Phone No.',
          dataIndex: 'phone_number',
          key: 'phone_number',
          width: '20%',
          render:(field, record) => {
            return <div onClick={()=>{onInfoClick(record)}}>{formatPhoneNumber(field)}</div>
          }
        },
        {
          title: 'Emp Type',
          dataIndex: 'restaurant_roles',
          key: 'restaurant_roles',
          width: '10%',
          render:(field, record) => {
            return <div onClick={()=>{onInfoClick(record)}}>{field[0]?.employee_type?.name}</div>
          }
        },
        {
          title: 'Emp ID',
          dataIndex: 'restaurant_roles',
          key: 'restaurant_roles',
          width: '10%',
          render:(field, record) => {
            return <div onClick={()=>{onInfoClick(record)}}>{field[0]?.employee_code}</div>
          }
        },
        {
          title: 'Status',
          dataIndex: 'is_active',
          key: 'is_active',
          width: '10%',
          render:(field, record) => {
            return <div onClick={()=>{onInfoClick(record)}}>{record.is_active? "Active" : "Deactivated"}</div>
          }
        },
        {
            title: '',
            width: '15%', 
            render: (_, record) => {
                return <div
                    style={{
                        display: "flex", width: '120px'}}>
                        <>
                            <img src={Edit} alt="" className="update_action" onClick={(e) => {
                                e.stopPropagation()
                                onEditClick(record);
                            }} /> &nbsp;&nbsp;
                            <img src={Delete} alt="" className="update_action" onClick={(e)=>{
                              e.stopPropagation()
                              onDelete(record)}}/>  &nbsp;&nbsp;
                        </>
                </div>
            }
        }
      ]
    return <div className="table_section">
    <Table 
      columns={columns} 
      loading={loading} 
      bordered 
      dataSource={userList?.employees || []} 
      className="customise-table overflow-auto" 
      pagination={{
        onChange: page =>{
          setDefaultPage(page);
        },
        current: defaultPage,
        pageSize: 10,
        total: userList?.total,
        hideOnSinglePage: true,
        showSizeChanger: false
      }}
    />
  </div>
};
export default TableSection;